import {mapGetters, mapState,mapMutations} from 'vuex'
import api from '@/utils/api/appoint'
export default {
  data() {
    return {
      configData: ''
    }
  },
  computed: {
    ...mapGetters('form', ['getFormConfigByName', 'getSubmitFormConfig']),
    ...mapState('form', ['formConfig']),
    data() {
      // return this.formConfig.filter(
      //   element => element.componentName == this.$route.name
      // )[0]
      return this.getFormConfigByName(this.$route.name)
    },
    navTitle() {
      if (this.data) {
        if (this.data.componentDesc) {
          return this.data.componentDesc
        }
      }
      return ''
    },
    componentData: {
      get() {
        if (this.data) {
          if (this.data.data) {
            return this.data.data
          }
        }
        return {}
      },
      set(val) {
        this.formConfig.forEach(element => {
          if (element.componentName == this.$route.name) {
            element.data = val
          }
        })
      }
    },
    permission:{
      get(){
        if(this.data?.permission){
          return this.data.permission
        }
        return {}
      },
      set(val){
        console.log(val)
      }
    }
  },
  methods: {
    ...mapMutations('form',['setRid']),
    toNext() {
      const configList = this.formConfig
      const componentName = this.$route.name
      for (let i = 0; i < configList.length; i++) {
        if (configList[i].componentName == componentName) {
          for (let n = 1; n < configList.length - i; n++) {
            if (configList[i + n].isShow) {
              this.$router.push({name: configList[i + n].componentName})
              break
            }
          }
        }
      }
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    widgetType(key) {
      let type = 'text'
      switch (key) {
        case 'GCXMFL':
          type = 'select'
          break
        case 'HTQDRQ':
          type = 'date'
          break
        case 'HTGQ':
          type = 'number'
          break
        case 'HTJE':
          type = 'price'
          break
        case 'HTMC':
          type = 'select'
          break
        case 'XMYSRQ':
          type = 'date'
          break
        case 'FWNR':
          type = 'textarea'
          break
      }
      return type
    },
    isFillable(item) {
      if (this.$store.state.formType === 1) {
        //修改
        return this.bool(item.isFillableModify)
      }
      return this.bool(item.isFillableNew)
    },
    bool(str) {
      if (str == 'true') {
        return true
      }
      if (str == 'false') {
        return false
      }
    },
    saveTempData(name){
      const data = this.getSubmitFormConfig(name)
      api.submitEntrust({data:data,type:2,moduleName:'PreBusiness'}).then(res=>{
        const rid = res.data
        this.setRid(rid)
      })
    }
  },
  created() {},
  mounted() {
    // console.log('show:', this.data.isShow)
    // if (!this.data.isShow) {
    //   this.toNext()
    // }

    for (let i = 0; i < this.formConfig.length; i++) {
      if (this.formConfig[i].componentName == this.$route.name) {
        this.configData = this.formConfig[i].data
      }
    }
  }
}
